import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Label from 'src/components/Label';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import UserListHead from '../../sections/@dashboard/user/UserListHead';
import NoPostFound from '../publishedPosts/noPost.component';
import RolesToolbar from './rolesToolbar';

const ManageRoles = () => {
  const { t: translate } = useTranslation();
  const [roles, setRoles] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const { showToast } = useToaster();
  const [height, setHeight] = useState(window.innerHeight - 250);

  useEffect(() => {
    getAllRoles();
  }, []);

  const getAllRoles = () => {
    setLoader(true);
    let postProps = {
      url: userModuleURL.getAllRoles,
      successCallback,
      failureCallback,
    };
    HttpServices.Get(postProps);
  };

  const successCallback = (data, message) => {
    message && showToast(message, 's');
    setLoader(false);
    setRoles(data);
  };

  const failureCallback = (message) => {
    showToast(message, 'e');
    setLoader(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getRolePermissionView = (rolePermission) => {
    return rolePermission?.role_permissions
      ?.filter((a) => a.has_permission)
      .map((permission) => {
        return (
          <Label color="primary" style={{ margin: 0.5 }}>
            {permission.permission_display_name}
          </Label>
        );
      });
  };

  const handleRoleCreated = (message) => {
    message && showToast(message, 's');
    getAllRoles();
  };

  return (
    <>
      <Helmet>
        <title>{translate('manage_brand.manage_roles.title')}</title>
      </Helmet>
      {loader ? (
        <Spinner />
      ) : (
        <>
          {roles && roles.length > 0 ? (
            <Card sx={{ m: 1 }}>
              <RolesToolbar handleSuccess={handleRoleCreated} />
              <TableContainer
                sx={{
                  minHeight: 'calc(100vh - 305px)',
                  maxHeight: 'calc(100vh - 305px)',
                }}
              >
                <Table aria-label="collapsible table" stickyHeader>
                  <UserListHead
                    headLabel={[
                      {
                        id: 'role',
                        label: translate('common.table.role'),
                        width: '15%',
                        alignCenter: false,
                      },
                      {
                        id: 'Permissions',
                        label: translate('common.table.permissions'),
                        width: '75%',
                        alignRight: false,
                      },
                      {
                        id: 'action',
                        label: 'Type',
                        width: '10%',
                        alignCenter: true,
                      },
                    ]}
                    rowCount={roles.length}
                    isShowCheckbox={false}
                    style={{ whiteSpace: 'nowrap' }}
                  />
                  <TableBody>
                    {roles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((role) => (
                      <TableRow hover key={role.id} tabIndex={-1}>
                        <TableCell align="left">{role.role_name}</TableCell>
                        <TableCell align="left">{getRolePermissionView(role)}</TableCell>
                        <TableCell align="center">Built-in</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 15, 25]}
                count={roles.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />

            </Card>
          ) : (
            <Card sx={{ minHeight: 'calc(100vh - 150px)', maxHeight: 'calc(100vh - 150px)' }}>
              <RolesToolbar handleSuccess={handleRoleCreated} />
              <NoPostFound height={height} />
            </Card>
          )}
        </>
      )}
    </>
  );
};

export default ManageRoles;
